import { useCurrentUser } from '@/api/auth';
import { WeeklyTemplateEditor } from '@/components/WeeklyTemplateEditor';
import { PageHelp } from '@/components/ui/PageHelp';

export default function MyAvailabilityPage() {
  const { data: user } = useCurrentUser();
  const empId = user?.employeeId ?? undefined;

  return (
    <div className="space-y-5">
      <div>
        <div className="text-[11px] uppercase tracking-[0.15em] text-slate-500 font-medium mb-1">
          Mon rythme de travail
        </div>
        <h2 className="text-[26px] font-semibold tracking-tight leading-tight">
          Mes <span className="text-primary">disponibilités</span> hebdomadaires{' '}
          <PageHelp topic="myAvailability" />
        </h2>
      </div>

      {empId ? (
        <WeeklyTemplateEditor employeeId={empId} selfMode />
      ) : (
        <div className="text-[13px] text-slate-500">
          Aucun salarié rattaché à ce compte.
        </div>
      )}
    </div>
  );
}
